import { Box, styled } from "@mui/material";
import { colorPickerName } from "../../../../../classes.js";
const HueCursor = styled(Box, {
  name: colorPickerName,
  overridesResolver: (_props, styles) => [styles.hueCursor],
  slot: "HueCursor"
})(({ theme }) => ({
  border: `${theme.spacing(0.25)} solid ${theme.palette.common.white}`,
  borderRadius: "50%",
  boxShadow: `0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.2)`,
  cursor: "ew-resize",
  height: theme.spacing(2),
  position: "absolute",
  top: "50%",
  transform: "translate3d(-50%, -50%, 0)",
  width: theme.spacing(2),
  zIndex: 100
}));
export {
  HueCursor
};
//# sourceMappingURL=HueCursor.js.map
